import { Component } from 'react';
import MarketsService from '../utils/MarketsService';

class RootGameOdds extends Component {
    currentTab = '0';

    getMarkets(condition, markets) {
        if (markets) {
            let filteredMarkets = markets.filter((market) => {
                let status = MarketsService.validator(condition, market);
                return status;
            });

            return filteredMarkets && filteredMarkets.length > 0
                ? filteredMarkets
                : false;
        } else {
            return false;
        }
    }

    onTabChanged(index) {
        this.currentTab = index;
    }

    render() {
        return null;
    }
}

export default RootGameOdds;
